import React, { Component } from 'react';
import './TextInput.css';

class TextInput extends Component {
	constructor(props) {
		super(props);
		this.onTextChange = this.onTextChange.bind(this);
	}

	componentDidMount() {}

	componentWillUnmount() {}

	onTextChange(e) {
		this.props.onTextChange(e.target.value);
	}

	render() {
		return (
			<label htmlFor={this.props.inputId}>
				{this.props.label}
				<input
					type="text"
					id={this.props.inputId}
					placeholder={this.props.placeholder}
					value={this.props.value}
					readOnly={this.props.readonly}
					onChange={this.onTextChange}
				/>
			</label>
		);
	}
}

export { TextInput };



// WEBPACK FOOTER //
// ./src/components/inputs/textinput/TextInput.js